export const safeNext = (next, fallback = "/channels") =>
  next && /^\/(?![/\\])/.test(next) && !/[\\\s\x00-\x1f]/.test(next) ? next : fallback;
